export default __webpack_public_path__ + "static/media/owl.d8ba6ec6.png";